export const MEDIA_LIB_FOLDERS = {
  myImages: 'My_Images',
  aiImages: 'ai_images',
  aiVideos: 'ai_videos',
  aiCharacters: 'ai_characters'
} as const
